<div role="button" tabindex="0" class="svg-icon svg-icon-left" on:click on:keyup={() => {}}>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 10" class="design-iconfont">
    <g fill-rule="nonzero" stroke="#000" stroke-width="2" fill="none" stroke-linecap="round">
      <path d="M7.09751406 8.09751406L2 3" transform="rotate(90 7.75 8.25)" />
      <path d="M7.09751406 8.09751406L2 13.1950281" transform="rotate(90 7.75 8.25)" />
    </g>
  </svg>
</div>

<style>
  .svg-icon {
    height: 1em;
    width: 1em;
    fill: currentColor;
    overflow: hidden;
  }

  .svg-icon-left {
    transform: rotate(90deg);
  }
</style>
